<template>
  <div>
    <!-- 自定义消息 -->
    <div class="reply-wrapper">
      <div class="row-1">
        " {{ fromName }} <span class="date">{{ date }}</span>
      </div>
      <div class="row-2">
        <template v-for="(item, index) in contentListReply">
          <span :key="index" v-if="item.name === 'text'" class="texts" v-html="item.text"></span>
          <img v-else-if="item.name === 'img'" :src="item.src" width="20" height="20" />"
        </template>
      </div>
    </div>
    <div class="texts">
      <template v-for="(item, index) in contentList">
        <span :key="index" v-if="item.name === 'text'" class="texts" v-html="item.text"></span>
        <img v-else-if="item.name === 'img'" :src="item.src" width="20" height="20" />
      </template>
    </div>
  </div>
</template>
<script>
import { transferDate } from "@/utlis/date";
// import { decodeText } from "@/utils/decodeText";
import { decodeText } from "./js/decodeText";
export default {
  props: {
    message: {
      type: Object,
    },
  },
  data() {
    return {};
  },
  computed: {
    fromName() {
      return JSON.parse(this.message.Ext).nick;
    },
    date() {
      return transferDate(new Date(JSON.parse(this.message.Ext).time * 1000));
    },
    contentList() {
      return decodeText({
        text: this.message.Desc,
      });
    },
    contentListReply() {
      let message = JSON.parse(this.message.Ext);
      return decodeText(message.payload);
    },
  },
  methods: {},
};
</script>
<style lang="scss">
.reply {
  padding: 0 10px 0 10px;
  // background-color: #f5f5f5;
  font-size: 12px;
  color: #666;
}
</style>
<style lang="scss" scoped>
.text {
  color: #333;
}

.reply-wrapper {
  font-size: 12px;
  color: #666;
  background-color: #efefef;
  padding: 3px 10px;

  .date {
    margin-left: 5px;
  }
}

.texts {
  word-wrap: break-word;
  word-break: break-all;
  max-width: 510px;
}
</style>